const europeanNationalities: string[] = [
  'Austriaca',
  'Belga',
  'Bulgaria',
  'Ceca',
  'Cipriota',
  'Croata',
  'Danese',
  'Estone',
  'Finlandese',
  'Francese',
  'Tedesca',
  'Greca',
  'Irlandese',
  'Lettone',
  'Lituana',
  'Lussemburghese',
  'Maltese',
  'Olandese',
  'Polacca',
  'Portoghese',
  'Romena',
  'Slovacca',
  'Slovena',
  'Spagnola',
  'Svedese',
  'Ungherese',
];
export default europeanNationalities;
